module.exports = {"it":{},"en":{}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n-defaults.json
// module id = 135
// module chunks = 0